
import React from "react";
import { Chip } from "../Chip";


interface TagPillProps {
    label: string;
    selected?: boolean;
    onClick?: () => void;
  }
  
  export const TagPill = ({ label, selected = false, onClick }: TagPillProps) => {
    return (
      <Chip
        label={`#${label}`}
        color="info"
        size="small"
        selectable
        selected={selected}
        onClick={onClick}
      />
    );
  };